import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IFailureAction } from "interfaces/fetch-duck";

export interface IState {
  data: any;
  loading: boolean;
  error: string | null;
}
export interface ISuccessAction {
  data: any;
}

const { Types, Creators } = createActions(
  {
    request: ["id"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "TAGINDEX_" }
);

export interface TagIndexState extends IState {}

const INITIAL_STATE: TagIndexState = {
  data: "general",
  loading: false,
  error: null,
};

const request = (state: TagIndexState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });
const success = (state: TagIndexState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });
const failure = (state: TagIndexState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });
const reset = () => INITIAL_STATE;

export const fetchTagIndex = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchTagIndexTypes = Types;
export const FetchTagIndexActions = Creators;
